import { PhoneUploadFile } from './phone-upload.models';

/** Gives up on a file that never reports success or failure, so the queue keeps moving. */
const FILE_TIMEOUT_MS = 60000;
/** The galleries click the uploader's Done button 1s after a success; start the next file after that. */
const NEXT_FILE_AFTER_MS = 1500;

/**
 * The gallery uploaders run with multiple="false", so a second file added while
 * the first is still in the list fails validation. Phone files can arrive several
 * per code, so this adds them one at a time: clear the list, add by UUID, wait for
 * that file's upload event, then move on. The gallery's own file-upload-success
 * handler saves each one.
 */
export class PhoneFileFeeder {
  private queue: PhoneUploadFile[] = [];
  private busy = false;

  constructor(private getApi: () => any, private getProvider: () => HTMLElement | null) {}

  public add(files: PhoneUploadFile[]): void {
    this.queue.push(...files);
    this.next();
  }

  private next(): void {
    const api = this.getApi();
    const provider = this.getProvider();
    if (this.busy || !api || !provider || !this.queue.length) {
      return;
    }
    const file = this.queue.shift();
    this.busy = true;

    let timeout: ReturnType<typeof setTimeout>;
    const onEvent = (event: any) => {
      if (event?.detail?.uuid === file.uuid) {
        finish();
      }
    };
    const finish = () => {
      clearTimeout(timeout);
      provider.removeEventListener('file-upload-success', onEvent);
      provider.removeEventListener('file-upload-failed', onEvent);
      setTimeout(() => {
        this.busy = false;
        this.next();
      }, NEXT_FILE_AFTER_MS);
    };
    provider.addEventListener('file-upload-success', onEvent);
    provider.addEventListener('file-upload-failed', onEvent);
    timeout = setTimeout(finish, FILE_TIMEOUT_MS);

    api.removeAllFiles();
    api.addFileFromUuid(file.uuid, { fileName: file.original_filename || undefined });
  }
}
